var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtabg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1673,
    height: 450,
    viewBox: "0 0 1673 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1673,
    height: 450,
    fill: "url(#paint0_linear_26_107)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_107",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1673,
    height: 450
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1673,
    height: 450,
    fill: "url(#paint1_linear_26_107)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_107)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.17,
    filter: "url(#filter0_d_26_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1358.06 -21.8305C1207.88 -37.2942 1185.33 90.1796 1192.97 156.449C1212.38 262.278 1324.95 326.157 1369.62 348.748C1405.35 366.822 1483.08 440.738 1517.48 475.437C1653.56 558.745 1700.07 402.397 1709.42 375.07C1718.78 347.743 1725.69 250.066 1781.03 175.942C1825.31 116.642 1847.19 52.3811 1852.59 27.6629C1864 -83.3307 1808.03 -102.716 1783.61 -110.744C1759.2 -118.772 1704.6 -115.149 1611.96 -39.8607C1537.84 20.37 1411.91 -2.34451 1358.06 -21.8305Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 0H1518.5L695.5 450H0V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_107",
    x: 1152.67,
    y: -148.712,
    width: 740.43,
    height: 691.346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.733333 0 0 0 0 0.945098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_107",
    x1: 0,
    y1: 0,
    x2: 1669.6,
    y2: 296.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2EAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_107",
    x1: 0,
    y1: 0,
    x2: 1669.6,
    y2: 296.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2EAEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtabg);
export default __webpack_public_path__ + "static/media/ctabg.5e7c58e4d0cfe73d0c1188a534765c77.svg";
export { ForwardRef as ReactComponent };